import { gql } from '__generated__'

export const SELLER_LIST_BUILDER_EXPORT_MUTATION = gql(/* GraphQL */`
  mutation SellerListBuilderExport(
    $input: SellerListBuilderPreviewInput!
    $target: SellerListBuilderExportTargetInput!
  ) {
    sellerListBuilderExport(input: $input, target: $target) {
      id
      marketingListId
      listType
      currentOffset
      taskId
    }
  }
`)
